// extracted by mini-css-extract-plugin
var _1 = "EmailTableRowMessage-modulecontainer__MoeyK";
var _2 = "EmailTableRowMessage-modulemessage___bkTf";
var _3 = "EmailTableRowMessage-modulemessageContainer__YeA9S";
var _4 = "EmailTableRowMessage-modulemessageCounter__nHJdG";
var _5 = "EmailTableRowMessage-modulenotes__Qc5Zq TableCellNote-moduleTableCellNote__Yb5FN";
var _6 = "EmailTableRowMessage-modulepriority__IJAjT EmailPriorityTag-moduleEmailPriorityTag__bvVxa IconNG-moduleiconContainer__SxWZ0";
var _7 = "EmailTableRowMessage-modulesubject__ddJue EmailTableRowMessage-moduletextStyles__yeFRY";
var _8 = "EmailTableRowMessage-moduletext__vS7VD EmailTableRowMessage-moduletextStyles__yeFRY";
var _9 = "EmailTableRowMessage-moduletextContainer__GOJGG";
var _a = "EmailTableRowMessage-moduletextStyles__yeFRY";
export { _1 as "container", _2 as "message", _3 as "messageContainer", _4 as "messageCounter", _5 as "notes", _6 as "priority", _7 as "subject", _8 as "text", _9 as "textContainer", _a as "textStyles" }
